import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  margin-bottom: ${cssTheme.layout.spacing.s300};
`

const CTAWrapper = styled.div`
  margin-top: ${cssTheme.layout.spacing.s400};
  width: 100%;
`

const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s600};
`

export const PrimaryDefaultLayout: React.FC<
  OfferLayoutBaseProps | OfferLayoutLoadingProps
> = ({
  priceComponent,
  isLoading,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  cashbackComponent,
  dataId
}) => {
  const {showCashbackOnLeft, showCashbackOnRight} = useCashbackPositioning({
    cashbackComponent
  })

  if (isLoading)
    return (
      <SkeletonWrapper>
        <div>
          <SkeletonLoader width={58} />
          <SkeletonLoader width={85} />
        </div>
        <SkeletonLoader width={201} marginTop={0} />
      </SkeletonWrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      <HeaderWrapper>{tagComponent}</HeaderWrapper>
      <BodyWrapper>
        <Box paddingLeft="s200" paddingRight="s200">
          {priceComponent}
          {providerLogoComponent}
          {roomLabelsComponent}
          {showCashbackOnLeft && <div>{showCashbackOnLeft}</div>}
          {showCashbackOnRight && <div>{showCashbackOnRight}</div>}
        </Box>
        <CTAWrapper>{ctaComponent}</CTAWrapper>
      </BodyWrapper>
    </Wrapper>
  )
}
